import axios from 'axios';
import { toast } from 'sonner';
import { Capacitor } from '@capacitor/core';

export const SEL_API = `${process.env.REACT_APP_BACKEND_URL}/api/selections`;

const startTime = (picks = []) => picks
  .filter((p) => p.match_date && p.match_time)
  .map((p) => `${p.match_date} ${p.match_time}`)
  .sort()[0]?.slice(11, 16);

// automatic name ("Selezione 31/10/2026 11:42") is left out so "selezione" isn't repeated
const isAutoName = (d = '') => /^Selezione \d{2}\/\d{2}\/\d{4}/.test(d.trim());

// betstatus style: "Questa è la mia selezione: SABATO VINCENZO inizio ore 15:00 GEKXS <link>"
export const shareText = (sel, url, ownerName = sel.owner_name) => {
  const time = startTime(sel.picks);
  const name = isAutoName(sel.description) ? '' : (sel.description || '').trim().toUpperCase();
  const parts = [name, (ownerName || '').toUpperCase(), time && `inizio ore ${time}`, sel.booking_code, url].filter(Boolean);
  return `Questa è la mia selezione: ${parts.join(' ')}`;
};

export const shareSelection = async (sel) => {
  try {
    const [{ data }, me] = await Promise.all([
      axios.post(`${SEL_API}/${sel.selection_id}/share`),
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/referral/me`).then((r) => r.data).catch(() => null),
    ]);
    // the link carries the sharer's invite code, like shared analyses (never for admin: no friend bonus)
    const url = data.invite !== false && me?.code ? `${data.url}?ref=${me.code}` : data.url;
    const text = shareText(sel, url, data.owner_name);
    // link only inside the text: passing `url` too makes WhatsApp append it a second time
    if (Capacitor.isNativePlatform()) {
      const { Share } = await import('@capacitor/share');
      await Share.share({ title: 'La mia selezione', text });
    } else if (navigator.share) {
      await navigator.share({ title: 'La mia selezione', text });
    } else {
      await navigator.clipboard.writeText(text);
      toast.success('Link copiato!');
    }
  } catch (e) {
    if (e?.name !== 'AbortError' && e?.message !== 'Share canceled') toast.error('Impossibile creare il link, riprova');
  }
};
